import { createAction } from '@ngrx/store';

export const mixpanelSetup = createAction('[User Tracking] Setting Up Mixpanel');
export const mixpanelEventSuccess = createAction('[User Tracking] Mixpanel Event Success');
